export enum SurveyView {

    web=0,
    uwp=1
}
